var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"ml-3 mr-3 mb-3"},[_c('v-card-title',{staticClass:"text-center"},[_vm._v(" "+_vm._s(_vm.statTitle)+" ")]),_c('v-card-text',{staticClass:"text-center text-xl"},[_vm._v(" "+_vm._s(_vm.total)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }